import { render, staticRenderFns } from "./RegisterProcess.vue?vue&type=template&id=9e217d52&"
import script from "./RegisterProcess.vue?vue&type=script&lang=js&"
export * from "./RegisterProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports